<template>
<div class='line-chart-div' :class="{inlineDiv: config.isInline}">


<!-- highlight click -->
<div v-if="config.tooltip" class='chart-hover-div' :class="{inlineDiv: config.isInline}" > 
  <p v-if="activeEp.title==null" class='chart-hover-instructions'>hover over line for more info</p>
  <p v-if="activeEp.title!=null" class='chart-hover-text'>
    <span :style="{color: yMetrics.length > 1 ? 'white' : colorSeason( activeEp.se )}">
      s{{ activeEp.se }}e{{ activeEp.ep }}, {{ activeEp.title }},
    </span>
    <span v-if="yMetrics.includes('rating')" :style="{color: colorSeason(activeEp.se)}">
      {{ activeEp.rating }} stars
    </span>
    <span v-if="yMetrics.length > 1">
      ,
    </span>
    <span v-if="yMetrics.includes('viewers')" :style="{color: yMetrics.length > 1 ? colorSeason2( activeEp.se ) : colorSeason( activeEp.se )}">{{ activeEp.viewers }} million viewers
    </span>
  </p>
</div>

<!-- line-chart -->
<div id='line-rating' :class="{inlineDiv: config.isInline}">
  <svg :height="fullHeight" :width="fullWidth" @mousemove.stop="handleMouseMove($event)" @mouseleave="handleMouseLeave()">
    <!-- gridlines -->
    <rect 
      class='gridline-line' 
      v-for="i in [0, 1, 2, 3, 4, 5]" :key="i" 
      :transform="'translate(0,' + (margins[0]+i*height/6) +')'" 
      height="1" :width="fullWidth" 
      :opacity="config.gridlineOpacity" 
      fill="white" 
    />
    <!--    and one for the very bottom -->
    <rect
      class='gridline-line' 
      :transform="'translate(0,' + (margins[0]+height-1) + ')'"
      height="1" :width="fullWidth" 
      :opacity="config.gridlineOpacity" 
      fill="white" 
    />
    <!-- y-axis labels for RATING -->
    <g v-if="yMetrics.includes('rating') & config.legend" transform="translate(0,0)">
      <text 
        v-for="j in [0,1,2,3,4,5]" :key="j"
        class='gridline-tex no-highlight' 
        :transform="'translate(0,' + (margins[0]+(6-j)*height/6 - 5) + ')'"
        text-anchor="start"
        alignment-baseline="top"
        fill="gray" >
          {{ j+4+" stars" }}
      </text>
    </g>
    <!-- y axis for VIEWERS -->
    <g v-if="yMetrics.includes('viewers') & config.legend">
      <!-- left labels -->
      <g v-if="yMetrics.length === 1" transform="translate(0, 0)">
        <!-- min -->
        <text 
          class='gridline-text no-highlight' 
          :transform="'translate(0,' + (margins[0]+20) + ')'"
          text-anchor="start"
          alignment-baseline="top"
          fill="gray">
            {{ yRange[1] }} million
        </text>    
      </g>
      <!-- right laels -->
      <g v-if="yMetrics.length === 2" transform="translate(0, 0)">
        <!-- min -->
        <text 
          class='gridline-text no-highlight' 
          :transform="'translate(' + fullWidth + ',' + (margins[0]+20) + ')'"
          text-anchor="end"
          alignment-baseline="top"
          fill="gray">
            {{ y2Range[1] }} million
        </text>    
        <!-- max -->
        <text 
          class='gridline-text no-highlight' 
          :transform="'translate(' + fullWidth + ',' + (margins[0]+height-5) +')'"
          text-anchor="end"
          alignment-baseline="bottom"
          fill="gray">
            {{ y2Range[0] }}
        </text>
      </g>
    </g>

    <!-- other lines for INACTIVE shows -->
    <g :transform="'translate(' + margins[0] + ',' + margins[1] + ')'">
      <path
        v-for="show in inactiveShowNames"
        :key="show"

        class="line"
        id="background-line"

        fill="none"
        stroke-width="1"
        stroke="white"
        opacity=".2"

        :d="myLine(myFilterObj(showData, {'show': show}))" 
        
        @mouseenter="handleLineFocus($event, show)"
        @mouseout="handleLineDefocus($event)"
        @click="bgLineClick(show)"
        cursor="pointer"

      />

      <text 
        class='bg-tooltip no-highlight' 
        :transform="'translate(' + (fullWidth-margins[1]) + ',' + height*1/12 + ')'" 
        text-anchor="end"
        alignment-baseline="middle"
        fill="white">
      </text>
    </g>

    <!-- main show lines -->
    <g :transform="'translate(' + margins[0] + ',' + margins[1] + ')'">
      <path
        v-for="season in activeShowSeasons"
        :key="season"

        class="line"

        fill="none"
        :stroke-width="config.strokeWidth"
        :stroke="colorSeason(season)"

        :d="myLine(myFilterObj(activeShowData, {'se': season}))" />
    
      <circle class='activeEpCircle'/>
      <circle class='activeEpCircle2'/>
    </g>

    <!-- y2 lines -->
    <g v-if="config.y2" :transform="'translate(' + margins[0] + ',' + margins[1] + ')'">
      <path
        v-for="season in activeShowSeasons"
        :key="season"

        class="line"

        fill="none"
        :stroke-width="config.strokeWidth"
        :stroke="colorSeason2(season)"

        :d="myLine2(myFilterObj(activeShowData, {'se': season}))" />
    </g>
  </svg>
</div>


<!-- season legend -->
<div v-if="config.legend" class='line-chart-season-headers is-hidden-mobile' >
  <svg height="20" :width="fullWidth" :transform="'translate(' + margins[1] + ', 0)'">
    <g v-for="(season, i) in activeShowSeasons" :key="i">
      <text 
        class='no-highlight'
        :transform="'translate(' + (activeShowSeasonScale(season)) + ',' + (10) + ')'"
        fill="white"
        text-anchor="middle"
        alignment-baseline="central"
        >s{{ season }}
      </text>
    </g>
  </svg>
</div>

<!-- legend with lines -->
<div v-if="yMetrics.length === 2" class='line-legend'>
  <!-- metric1 -->
  <div>
    <svg height="20" :width="width" transform="translate(0, 0)">
      <rect 
        height="2" :width="30"
        :fill="this.config.color1"
        :transform="'translate(0, ' + (20/2) +')'"
      />
      <rect 
        height="2" :width="30"
        :fill="this.config.color2"
        :transform="'translate(' + (5+30) + ',' + (20/2) +')'"
      />
      <text
        class='no-highlight'
        height="20"
        :width="width"
        :transform="'translate(' + (30*2 + 5*2 + 10) + ',' + (20/2) + ')'"
        fill="gray"
        text-anchor="start"
        alignment-baseline="central"
      >
       Average IMDB Rating 
      </text>
    </svg>
  </div>

  <!-- metric2 -->
  <div>
    <svg height="20" :width="width" transform="translate(0, 0)">
      <rect 
        height="2" :width="30"
        :fill="this.config.color3"
        :transform="'translate(0, ' + (20/2) +')'"
      />
      <rect 
        height="2" :width="30"
        :fill="this.config.color4"
        :transform="'translate(' + (5+30) + ',' + (20/2) +')'"
      />
      <text
        class='no-highlight'
        height="20"
        :width="width"
        :transform="'translate(' + (30*2 + 5*2 + 10) + ',' + (20/2) + ')'"
        fill="gray"
        text-anchor="start"
        alignment-baseline="central"
      >
       Average Viewers per Episode
      </text>
    </svg>
  </div>
</div>

</div>
</template>


<script>
import filter from "lodash.filter"
import uniq from "lodash.uniq"
import map from "lodash.map"
import reject from "lodash.reject"

import { line } from "d3-shape";
import { scaleLinear } from 'd3-scale';

import { myMin, myMax, filterObj } from '../js/helpers.js'

export default {
  props: {
    showData: Array,
    activeShowName: String,
    config: Object,
    resize: Date
  },
  data() {
    return {
      activeShowSeasons: 0,
      activeShowData: [],
      activeShowXVals: [],
      inactiveShowNames: [],
      xRange: [0, 0],
      yRange: [0, 0],
      y2Range: [0, 0],
      yMetrics: [],
      height: 0,
      width: 0,
      fullHeight: 0,
      fullWidth: 0,
      margins: [10, 10, 10, 10],
      activeEp: {},
    }
  },
  mounted() {
    this.updateMargins();
    this.setHeightWidth();
    this.updateXRange();
    this.updateYRange();
    this.updateY2Range();
    this.updateYMetrics();
    this.updateActiveShowData();
    this.updateActiveShowSeasons();
    this.updateActiveShowXVals();
    this.updateInactiveShowNames();
  },
  watch: {
    config() {
      this.updateMargins();
    },
    resize() {
      this.updateMargins();
      this.setHeightWidth();
    },
    showData() {
      this.updateActiveShowData();
      this.updateInactiveShowNames();
      this.updateActiveShowSeasons();
      this.updateXRange();
      this.updateYRange();
      this.updateY2Range();
      this.updateActiveShowXVals();
    },
    activeShowName() {
      this.updateActiveShowData();
      this.updateActiveShowXVals();
      this.updateActiveShowSeasons();
      this.updateInactiveShowNames();
      const tooltip = this.$el.querySelector('.bg-tooltip');
      tooltip.textContent = '';
    }
  },
  methods: {
    updateActiveShowXVals() {
      let vals = [];
      for (let i=0; i<this.activeShowData.length; i++) {
        vals.push(this.activeShowData[i][this.config.x.name])
      }
      vals.sort((a,b)=>a-b)
      this.activeShowXVals = vals;
    },
    updateMargins() {
      this.margins = this.config.margins == null ? this.margins : this.config.margins;
    },
    bgLineClick(showName) {
      this.$emit('setActiveShowName', showName)
    },
    handleLineFocus(event, show) {
      event.target.classList.add('highlighted-background-line');
      const tooltip = this.$el.querySelector('.bg-tooltip');
      tooltip.textContent = show;
    },
    handleLineDefocus(event) {
      event.target.classList.remove('highlighted-background-line');
      const tooltip = this.$el.querySelector('.bg-tooltip');
      tooltip.textContent = '';
    },
    handleMouseLeave() {
      if (this.config.tooltip) {
        this.activeEp = {};
        const element = this.$el.querySelector(".activeEpCircle")
        element.setAttribute("r", 0)


        const element2 = this.$el.querySelector(".activeEpCircle2")
        element2.setAttribute("r", 0)
      }
    },
    handleMouseMove(event) {
      if (this.config.tooltip) {
        // get location of mouse and turn it into a x-val
        const xCoord = event.offsetX - this.margins[1];
        const xPctOfPx = 1 - ((this.width - xCoord) / this.width);
        let xVal = this.xRange[0] + xPctOfPx*(this.xRange[1] - this.xRange[0])

        // find out which two values in the activeShowData that this xVal is closest to
        let index1 = 0;
        let index2 = 0;
        for (let i=0; i<this.activeShowXVals.length; i++) {
          if (xVal < this.activeShowXVals[i]) {
            index2 = i;
            break
          }
          index2 = i
        }
        index1 = index2 === 0 ? 0 : index2-1
        const distToIndex1 = xVal - this.activeShowXVals[index1];
        const distToIndex2 = this.activeShowXVals[index2] - xVal;
        const xValToHighlight = distToIndex1 < distToIndex2 ? this.activeShowXVals[index1] : this.activeShowXVals[index2];

        // get the ative ep using x-val
        const xName = this.config.x.name;
        const yName = this.config.y.name;
        this.activeEp = filter(this.activeShowData, [xName, xValToHighlight])[0];


        // set the location of the focus circle(s)
        const element = this.$el.querySelector(".activeEpCircle")
        element.setAttribute("transform", "translate(" + this.x(this.activeEp[xName]) + "," + this.y(this.activeEp[yName]) + ")");
        element.setAttribute("fill", this.colorSeason(this.activeEp.se))
        if (this.activeEp[yName] === null) {
          element.setAttribute("r", 0)
        } else {
          element.setAttribute("r", 8)
        }

        if (this.yMetrics.length > 1) {
          const y2Name = this.config.y2.name;
          const element2 = this.$el.querySelector(".activeEpCircle2")
          element2.setAttribute("transform", "translate(" + this.x(this.activeEp[xName]) + "," + this.y2(this.activeEp[y2Name]) + ")");
          element2.setAttribute("fill", this.colorSeason2(this.activeEp.se))
          if (this.activeEp[this.config.y2.name] === null) {
            element2.setAttribute("r", 0)
          } else {
            element2.setAttribute("r", 8)
          }
        }
      }
    },
    updateYMetrics() {
      if (Object.prototype.hasOwnProperty.call(this.config, 'y')) {
        this.yMetrics.push(this.config.y.name);   
      } 
      if (Object.prototype.hasOwnProperty.call(this.config, 'y2')) {
        this.yMetrics.push(this.config.y2.name);
      }
    },
    updateInactiveShowNames() {
      let showNames = uniq(map(this.showData, 'show'))
      showNames.sort(function (a, b) { 
        return a < b;
      })
      let out = []
      for (let i=0; i<showNames.length; i++) {
        if (showNames[i] != this.activeShowName) {
          out.push(showNames[i])
        }
      }
      this.inactiveShowNames= out;
    },
    myFilterObj(obj, filterDict) {
      return filterObj(obj, filterDict);
    },
    updateActiveShowData() {
      this.activeShowData = filterObj(this.showData, {'show': this.activeShowName })
    },
    activeShowSeasonScale(sNum) {
      // for this season, get the number of episodes
      const seasonData = filterObj(this.activeShowData, {'se': sNum})
      const minEpisode = myMin(seasonData, "id")
      const maxEpisode = myMax(seasonData, "id");
      const numEpisodesInSeries = myMax(this.activeShowData, "id");
      const numEpisodesInData = myMax(this.showData, "id");

      const minPct = minEpisode / numEpisodesInSeries;
      const maxPct =  maxEpisode / numEpisodesInSeries

      const overallPct = numEpisodesInSeries / numEpisodesInData;
      
      return this.width * overallPct * ( (maxPct + minPct)/2 )
    },
    setHeightWidth() {
      const height = Object.prototype.hasOwnProperty.call(this.config.shape, 'height') ? this.config.shape.height : this.$el.clientHeight
      const width = Object.prototype.hasOwnProperty.call(this.config.shape, 'width') ? this.config.shape.width : this.$el.clientWidth
      
      this.fullHeight = height;
      this.fullWidth = width;

      this.height = height - this.margins[0] - this.margins[2];
      this.width = width - this.margins[1] - this.margins[3];
    },
    updateActiveShowSeasons() {
      let seasons = uniq(map(this.activeShowData, 'se'))
      seasons.sort(function (a, b) { 
        return a < b;
      })
      this.activeShowSeasons = seasons;
    },    
    updateXRange() {
      const min = Object.prototype.hasOwnProperty.call(this.config.x, 'min') ? this.config.x.min : myMin(this.showData, this.config.x.name);
      const max = Object.prototype.hasOwnProperty.call(this.config.x, 'max') ? this.config.x.max : myMax(this.showData, this.config.x.name);
      this.xRange = [min, max]
    },
    updateYRange() {
      let min = Object.prototype.hasOwnProperty.call(this.config.y, 'min') ? this.config.y.min : myMin(this.showData, this.config.y.name);
      let max = Object.prototype.hasOwnProperty.call(this.config.y, 'max') ? this.config.y.max : myMax(this.showData, this.config.y.name);
      
      if (max < 20) {
        max = Math.ceil(max);
      } else if (max < 30) {
        max = Math.ceil(max / 5) * 5;
      } else if (max < 100) {
        max = Math.ceil(max / 10) * 10;
      } else {
        max = Math.ceil(max / 100) * 100;
      }

      this.yRange = [min, max]
    },
    updateY2Range() {
      if (Object.prototype.hasOwnProperty.call(this.config, 'y2')) {
        let min = Object.prototype.hasOwnProperty.call(this.config.y2, 'min') ? this.config.y2.min : myMin(this.showData, this.config.y2.name);
        let max = Object.prototype.hasOwnProperty.call(this.config.y2, 'max') ? this.config.y2.max : myMax(this.showData, this.config.y2.name);

        if (max < 20) {
          max = Math.ceil(max);
        } else if (max < 30) {
          max = Math.ceil(max / 5) * 5;
        } else if (max < 100) {
          max = Math.ceil(max / 10) * 10;
        } else {
          max = Math.ceil(max / 100) * 100;
        }

        this.y2Range = [min, max]
      }
    },
    myLine(data) {
      const config = this.config;
      const filteredData = reject(data, [config.y.name, null])
      var linePath = line()
        .x((d) => { return this.x(d[config.x.name]); }) // set the x values for the line generator
        .y((d) => { return this.y(d[config.y.name]); }) // set the y values for the line generator
      return linePath(filteredData)
    },
    myLine2(data) {
      const config = this.config;
      const filteredData = reject(data, [config.y2.name, null])
      var linePath = line()
        .x((d) => { return this.x(d[config.x.name]); }) // set the x values for the line generator
        .y((d) => { return this.y2(d[config.y2.name]); }) // set the y values for the line generator
      return linePath(filteredData)
    },
    x(val) {
      var scale = scaleLinear()
        .domain(this.xRange)
        .range([0, this.width]);
      return scale(val)
    },
    y(val) {
      var scale = scaleLinear()
        .domain(this.yRange)
        .range([this.height, 0]);
      return scale(val)
    },
    y2(val) {
      var scale = scaleLinear()
        .domain(this.y2Range)
        .range([this.height, 0]);
      return scale(val)
    },
    colorSeason(se) {
      if (se%2 === 1) {
        return this.config.color1
      } else {
        return this.config.color2
      }
    },
    colorSeason2(se) {
      if (se%2 === 1) {
        return this.config.color3
      } else {
        return this.config.color4
      }
    }
  }
}
</script>


<style lang='scss' scoped>
.line-background {
  fill: $bg-darkest;
}

.line-legend {
  padding-top: 2rem;
}

</style>
